<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
  <div class="relative w-full max-w-3xl bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 max-h-[92vh] overflow-y-auto">
    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">gavel</span>
        รายละเอียดเรื่องอนุมัติ
      </h3>
      <button (click)="onClose()" class="material-icons text-slate-400 hover:text-slate-600">close</button>
    </div>

    <ng-container *ngIf="detail">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">เลขที่</div>
          <div class="font-semibold">{{ detail.name }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">สถานะ</div>
          <span class="inline-block mt-1 px-2 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-600">
            {{ statusLabel(detail.status) }}
          </span>
        </div>
        <div class="md:col-span-2">
          <div class="text-xs font-bold text-slate-400 uppercase">หัวข้อ</div>
          <div>{{ detail.title || '-' }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">เมนู</div>
          <div>{{ detail.menuName || '-' }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">ประเภทเอกสาร</div>
          <div>{{ recordModelLabel(detail.recordModel) }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">ผู้ขอ</div>
          <div>{{ detail.requesterName || '-' }}</div>
        </div>
        <div>
          <div class="text-xs font-bold text-slate-400 uppercase">วันที่ส่ง</div>
          <div>{{ formatDate(detail.submittedDate) }}</div>
        </div>
        <div class="md:col-span-2" *ngIf="detail.requestRemark">
          <div class="text-xs font-bold text-slate-400 uppercase">หมายเหตุผู้ขอ</div>
          <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50">{{ detail.requestRemark }}</div>
        </div>
      </div>

      <div *ngIf="cardQuotaDetail" class="mb-6 p-4 rounded-2xl border border-amber-100 dark:border-amber-900/30 bg-amber-50/30 dark:bg-amber-900/10">
        <h4 class="font-bold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">confirmation_number</span>
          รายละเอียดคำขอโควต้าบัตร
        </h4>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
          <div><span class="text-slate-400">เลขที่:</span> {{ cardQuotaDetail.name }}</div>
          <div><span class="text-slate-400">Client:</span> {{ cardQuotaDetail.clientName }}</div>
          <div><span class="text-slate-400">ลาน:</span> {{ cardQuotaDetail.siteName }}</div>
          <div><span class="text-slate-400">ประเภท:</span> {{ requestTypeLabel(cardQuotaDetail.requestType) }}</div>
          <div><span class="text-slate-400">จำนวนขอ:</span> {{ cardQuotaDetail.requestedQty }}</div>
          <div><span class="text-slate-400">Level:</span> {{ cardQuotaDetail.quotaLevel }}</div>
        </div>
      </div>

      <div *ngIf="allocationRequestDetail" class="mb-6 p-4 rounded-2xl border border-blue-100 dark:border-blue-900/30 bg-blue-50/30 dark:bg-blue-900/10">
        <h4 class="font-bold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2">
          <span class="material-icons text-blue-500 text-[20px]">share</span>
          รายละเอียดคำขอจัดสรรโควต้า
        </h4>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
          <div><span class="text-slate-400">เลขที่:</span> {{ allocationRequestDetail.name }}</div>
          <div><span class="text-slate-400">Master Quota:</span> {{ allocationRequestDetail.masterQuotaName }}</div>
          <div><span class="text-slate-400">ร้านค้า:</span> {{ allocationRequestDetail.tenantClientName }}</div>
          <div><span class="text-slate-400">ลาน:</span> {{ allocationRequestDetail.siteName }}</div>
          <div><span class="text-slate-400">จำนวนขอ:</span> {{ allocationRequestDetail.requestedQty }}</div>
          <div><span class="text-slate-400">สถานะ:</span> {{ requestStatusLabel(allocationRequestDetail.status) }}</div>
          <div *ngIf="allocationRequestDetail.note" class="md:col-span-3"><span class="text-slate-400">หมายเหตุ:</span> {{ allocationRequestDetail.note }}</div>
        </div>
      </div>

      <div *ngIf="allocationDetail" class="mb-6 p-4 rounded-2xl border border-blue-100 dark:border-blue-900/30 bg-blue-50/30 dark:bg-blue-900/10">
        <h4 class="font-bold text-slate-700 dark:text-slate-200 mb-3 flex items-center gap-2">
          <span class="material-icons text-blue-500 text-[20px]">share</span>
          รายละเอียดการจัดสรรโควต้า
        </h4>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
          <div><span class="text-slate-400">เลขที่:</span> {{ allocationDetail.name }}</div>
          <div><span class="text-slate-400">Master Quota:</span> {{ allocationDetail.masterQuotaName }}</div>
          <div><span class="text-slate-400">ร้านค้า:</span> {{ allocationDetail.tenantClientName }}</div>
          <div><span class="text-slate-400">ลาน:</span> {{ allocationDetail.siteName }}</div>
          <div><span class="text-slate-400">จำนวนจัดสรร:</span> {{ allocationDetail.allocatedQty }}</div>
          <div><span class="text-slate-400">สถานะ:</span> {{ actionLabel(allocationDetail.action) }}</div>
        </div>
      </div>

      <div class="mb-6">
        <h4 class="font-bold text-slate-700 dark:text-slate-200 mb-3">ขั้นตอนอนุมัติ</h4>
        <div class="space-y-2">
          <div *ngFor="let step of detail.steps"
            class="p-3 rounded-xl border flex flex-wrap items-center justify-between gap-2"
            [ngClass]="step.stepNumber === detail.currentStep && step.status === 'pending'
              ? 'border-amber-300 bg-amber-50/50 dark:bg-amber-900/10'
              : 'border-slate-100 dark:border-slate-800'">
            <div>
              <div class="font-semibold">ชั้น {{ step.stepNumber }} — {{ step.stepName || 'ขั้นตอน ' + step.stepNumber }}</div>
              <div class="text-xs text-slate-400">
                <span *ngIf="step.assignedUserName">ผู้รับผิดชอบ: {{ step.assignedUserName }}</span>
                <span *ngIf="!step.assignedUserName && step.assignedRoleName">Role: {{ step.assignedRoleName }}</span>
                <span *ngIf="!step.assignedUserName && !step.assignedRoleName && step.assignedDepartmentName">
                  แผนก: {{ step.assignedDepartmentName }}
                </span>
              </div>
              <div *ngIf="step.actedByUserName" class="text-xs text-slate-500 mt-1">
                ดำเนินการโดย {{ step.actedByUserName }} — {{ formatDate(step.actedDate) }}
              </div>
              <div *ngIf="step.remark" class="text-xs text-slate-500 mt-1">หมายเหตุ: {{ step.remark }}</div>
            </div>
            <span class="px-2 py-1 rounded-full text-xs font-bold"
              [ngClass]="{
                'bg-amber-50 text-amber-600': step.status === 'pending',
                'bg-emerald-50 text-emerald-600': step.status === 'approved',
                'bg-rose-50 text-rose-600': step.status === 'rejected'
              }">
              {{ stepStatusLabel(step.status) }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="detail.canForward" class="mb-4">
        <label class="text-xs font-bold text-slate-400 uppercase">เลือกผู้อนุมัติชั้นถัดไป</label>
        <select [(ngModel)]="forwardUserId"
          class="w-full mt-1 px-4 py-2.5 rounded-xl border bg-slate-50 dark:bg-slate-800 dark:border-slate-700">
          <option [ngValue]="0">-- เลือกผู้อนุมัติ --</option>
          <option *ngFor="let c of detail.forwardCandidates" [ngValue]="c.userId">
            {{ c.userName }}<span *ngIf="c.roleName"> ({{ c.roleName }})</span>
          </option>
        </select>
      </div>

      <div *ngIf="detail.canAct || detail.canForward" class="mb-6">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
        <textarea [(ngModel)]="remark" rows="2" placeholder="หมายเหตุ (จำเป็นเมื่อปฏิเสธ)"
          class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800"></textarea>
      </div>

      <div class="flex flex-wrap justify-between gap-3 pt-4 border-t border-slate-100 dark:border-slate-800">
        <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 inline-flex items-center gap-1.5 cursor-pointer">
          <span class="material-icons text-base">history</span>
          ดูประวัติ
        </button>
        <div class="flex flex-wrap justify-end gap-3 ml-auto">
          <button (click)="onClose()" class="px-5 py-2.5 rounded-xl border font-semibold">ปิด</button>

          <ng-container *ngIf="detail.canForward">
            <button (click)="onForward()" [disabled]="isSubmitting() || !forwardUserId"
              class="px-5 py-2.5 rounded-xl bg-blue-500 text-white font-bold disabled:opacity-50">
              ส่งต่อผู้อนุมัติ
            </button>
          </ng-container>

          <ng-container *ngIf="detail.canAct">
            <button (click)="openRejectConfirm()" [disabled]="isSubmitting()"
              class="px-5 py-2.5 rounded-xl bg-rose-50 text-rose-600 font-bold disabled:opacity-50">
              ปฏิเสธ
            </button>
            <button (click)="openApproveConfirm()" [disabled]="isSubmitting()"
              class="px-5 py-2.5 rounded-xl bg-emerald-500 text-white font-bold disabled:opacity-50 flex items-center gap-1">
              <span class="material-icons text-[18px]">check_circle</span> อนุมัติ
            </button>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && requestId"
  [entityType]="activityEntityTypes.ApprovalRequest"
  [entityId]="requestId"
  title="ประวัติคำขออนุมัติ"
  [subtitle]="'#' + requestId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showApproveConfirm()" title="ยืนยันการอนุมัติ?" message="อนุมัติเรื่อง"
  [highlight]="detail?.name || ''" messageSuffix="หรือไม่?" confirmLabel="อนุมัติ" cancelLabel="ยกเลิก"
  variant="warning" icon="check_circle" [showIrreversibleNote]="false"
  (confirm)="confirmApprove()" (cancel)="closeApproveConfirm()">
</app-pss-confirm-modal>

<app-pss-confirm-modal *ngIf="showRejectConfirm()" title="ยืนยันการปฏิเสธ?" message="ปฏิเสธเรื่อง"
  [highlight]="detail?.name || ''" messageSuffix="หรือไม่?" confirmLabel="ปฏิเสธ" cancelLabel="ยกเลิก"
  variant="danger" icon="block" (confirm)="confirmReject()" (cancel)="closeRejectConfirm()">
</app-pss-confirm-modal>
